import { Checkbox, Field, Label } from '@headlessui/react';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

type FormCheckboxProps = {
    name: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    required?: boolean;
    error?: string;
    domainConfiguration: DomainConfigurationDto;
};

export default function FormCheckbox({
    name,
    label,
    checked,
    onChange,
    required = false,
    error,
    domainConfiguration
}: FormCheckboxProps) {
    return (
        <div className="space-y-2">
            <Field className="flex items-center gap-3">
                <Checkbox
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    className="group size-[16px] rounded-2 border-2 flex items-center justify-center transition-all duration-150 outline-none cursor-pointer focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)]"
                    style={
                        {
                            borderColor: error
                                ? '#ef4444'
                                : checked
                                  ? domainConfiguration.style.primaryColor
                                  : withOpacity(domainConfiguration.style.onSurfaceColor, 0.3),
                            backgroundColor: checked ? domainConfiguration.style.primaryColor : 'transparent'
                        } as React.CSSProperties
                    }>
                    <svg
                        className="opacity-0 group-data-[checked]:opacity-100 transition-opacity duration-150"
                        viewBox="0 0 14 14"
                        fill="none"
                        width="12"
                        height="12">
                        <path
                            d="M3 8L6 11L11 3.5"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ stroke: domainConfiguration.style.onPrimaryColor }}
                        />
                    </svg>
                </Checkbox>

                <Label
                    className="text-body-14 cursor-pointer"
                    style={{ color: domainConfiguration.style.onSurfaceColor }}>
                    {label}
                    {required && (
                        <span
                            style={{ color: '#ef4444' }}
                            className="ml-1">
                            *
                        </span>
                    )}
                </Label>
            </Field>
            {error && (
                <p
                    className="text-body-12 ml-5"
                    style={{ color: '#ef4444' }}>
                    {error}
                </p>
            )}
        </div>
    );
}
